

export default async function navigation_pin(navigationSectionId:string) {

    console.log("navigation_pin", navigationSectionId)

    gd.layout.toggleHideMenuForCurrentApp(true)

    gd.layout.navigation.navigationStructure.initSections()

    const section = gd.layout.navigation.navigationStructure.get(navigationSectionId)

    await gd.layout.navigation.setCurrentSection(section)

    // await gd.layout.navigation.reRender()
    await gd.layout.mainMenuStatic?.reRender()

    gd.bus.triggerEvent('navigation:settings-changed')
}
